import { gql } from '@apollo/client';

export const GET_TOOL_ORDER_HISTORY = gql`
  query GetToolOrderHistory($toolOrderId: ID!) {
    getToolOrderHistory(toolOrderId: $toolOrderId) {
      toolOrderHistory {
        id
        orderId
        status
        createdBy
        createdDate
        user {
          id
          firstName
          lastName
          roles {
            id
            name
          }
        }
      }
      error
    }
  }
`;

export const SEARCH_TOOL_ORDER_HISTORY = gql`
  query SearchToolOrderHistory($searchInput: SearchInput!) {
    searchToolOrderHistorys(searchInput: $searchInput) {
      items {
        id
        stats {
          toolsCount
          id
          consumablesCount
        }
        status
        createdDate
        createdBy
        createdByUser {
          id
          firstName
          lastName
          employee {
            id
            persona
            imageUrl
          }
        }
      }
    }
  }
`;
